/*
 * @Descripttion: 头部menu
 * @version:
 * @Author: AowCt <awoct10@163.com>
 * @Date: 2022-07-19 17:02:51
 * @LastEditors: AowCt <awoct10@163.com>
 * @LastEditTime: 2026-09-03 10:30:57
 */

const headMenus = {
  index: {
    name: '脉流科技-心脑血管病智能诊疗的领跑者',
    title: '首页'
  },
  innovative: {
    name: '脉流科技-产品与解决方案',
    title: '产品与解决方案',
    intracranial: '脑血管智能诊疗解决方案',
    aneurysm: ['颅内动脉瘤智能诊疗产品'],
    AneuFlow: 'AneuFlow-颅内动脉瘤辅助诊断系统',
    AneuPlan: 'AneuPlan-颅内动脉瘤手术方案规划系统',
    AneuGuide: 'AneuGuide-颅内动脉瘤实时手术规划系统',
    AneuShape: 'AneuShape-颅内动脉瘤微导管塑形产品',
    stroke: ['脑卒中诊断一站式分析产品'],
    AccuASPECTS: 'AccuASPECTS-ASPECTS自动化评分系统',
    AccuCTP: 'AccuCTP-颅内CT灌注影像自动化分析系统',
    narrow: ['颅内狭窄智能辅助治疗产品'],
    AccuFFicas: 'AccuFFicas-颅内动脉狭窄一站式评估系统',
    intracardiac: '心血管智能诊疗解决方案',
    accuffr: ['AccuFFR智能诊疗系列产品'],
    AccuFFRct: 'AccuFFRct-基于CTA的无创FFR技术',
    AccuFFRangio: 'AccuFFRangio-基于冠脉造影的FFR技术',
    AccuFFRivus: 'AccuFFRivus-基于IVUS的FFR技术',
    AccuFFRoct: 'AccuFFRoct-基于OCT的FFR技术',
    structureFunction: ['更多智能诊疗系列产品'],
    AccuLV: 'AccuLV-心脏无创功能学评估产品',
    AccuIMR: 'AccuIMR-微循环阻力评估系统',
    AccuVALVE: 'AccuVALVE-心脏瓣膜手术规划'
  },
  college: {
    name: '脉流科技-脉流学院',
    title: '脉流学院'
  },
  about: {
    name: '脉流科技-公司介绍',
    title: '公司介绍',
    outName: '脉流科技-关于脉流',
    outTitle: '关于脉流'
  },
  news: {
    name: '脉流科技-新闻动态',
    title: '新闻动态'
  },
  scienceResearch: {
    name: '脉流科技-科研合作',
    title: '科研合作',
    outName: '脉流科技-合作咨询',
    outTitle: '合作咨询'
  },
  license: {
    name: '脉流科技-申请许可',
    title: '申请许可'
  },
  job: {
    name: '脉流科技-招贤纳士',
    title: '招贤纳士'
  },
  privacyPolicy: {
    name: '脉流科技-隐私政策',
    title: '隐私政策'
  },
  useClause: {
    name: '脉流科技-使用条款',
    title: '使用条款'
  },
  guidance: {
    name: '脉流科技-方案咨询',
    title: '方案咨询'
  }
}
const footer = {
  cooperation: {
    title: '企业合作',
    list: [{ title: '科研合作: ' }, { title: 'rong.zou@arteryflow.com' }, { title: '市场合作: ' }, { title: 'lei.zhang@arteryflow.com' }]
  },
  product: {
    title: '产品系列',
    list: [ // 中文
      { title: '脑血管智能诊疗解决方案', url: '/innovative/intracranial' }, { title: '心血管智能诊疗解决方案', url: '/innovative/intracardiac' }
    ]
  },
  legal_provisions: {
    title: '法律条款',
    list: [{ title: '隐私政策', url: '/privacy_policy' }, { title: '使用条款', url: '/use_clause' }]
  },
  contactUs: {
    title: '联系我们',
    list: [{ des: ['浙江省杭州市滨江区阡陌路459号', '聚光中心C1座5楼'] }, { title: '电话：', des: ['0571-88106256', '19157686057'] }, { title: '邮箱：', des: ['infor@arteryflow.com'] }]
  },
  code: '微信公众号',
  bottom: {
    copy: 'Copyright©2020 杭州脉流科技有限公司 All Rights Reserved',
    network: '浙公网安备 33010802009609号',
    ICP: '浙ICP备17059686号-1'
  }
}
export default { headMenus: headMenus, footer: footer }
